<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>服務心得</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>服務心得</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-0" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="form-group">
                <label class="col-md-2 control-label">學　　號<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.studentId}}</div>
                <label class="col-md-2 control-label">姓　　名<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.studentName}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">班　　級<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.dradeClass}}</div>
                <label class="col-md-2 control-label">服務單位<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.deptName}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">服務時間<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-9">{{year-1911}} 年 {{month}} 月</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">服務心得<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-9">
                  <textarea style="width:100%" rows="8" v-model="form.content"></textarea>
                  <div style="text-align: right; font-size: 12px; color: #999; line-height: 12px;">(請輸入最少50字，最多300字)</div>
                </div>
              </div>
              <table width="100%">
                <tr>
                  <td align="center">
                    <a href="#" @click.prevent="formSubmit" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">送　　出</a>
                  </td>
                </tr>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      item: {},
      form: {
        content: ""
      }
    };
  },
  computed: {
    year() {
      return this.$route.params.year;
    },
    month() {
      return this.$route.params.month;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$http.get("/api/workstudyStudent/serviceFeedback/" + this.year + '/' + this.month).then(a => {
        this.item = a.body;
        this.form.content = this.item.serviceFeedback;
      });
    },
    formSubmit() {
      if (this.checkForm() == false) return;
      this.$http.post("/api/workstudyStudent/serviceFeedback/" + this.year + '/' + this.month, this.form).then(a => {
        if (a.body.status) {
          alert("儲存成功");
          this.$router.push("/student");
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
    checkForm() {
      if (!this.form.content || this.form.content.trim() == "")  {
        alert("『服務心得』尚未填寫");
        return false;
      }
      if (this.form.content.trim().length < 50)  {
        alert("『服務心得』最少請輸入50字");
        return false;
      }
      if (this.form.content.trim().length > 300)  {
        alert("『服務心得』最多可輸入300字");
        return false;
      }
      return true;
    }
  }
};
</script>

<style>
</style>